import { render, staticRenderFns } from "./Scope.vue?vue&type=template&id=4ae53d94&scoped=true&"
var script = {}
import style0 from "./Scope.vue?vue&type=style&index=0&id=4ae53d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae53d94",
  null
  
)

export default component.exports